import { render, staticRenderFns } from "./ProfilesBlock.vue?vue&type=template&id=adcd7650&scoped=true&"
import script from "./ProfilesBlock.vue?vue&type=script&lang=js&"
export * from "./ProfilesBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesBlock.vue?vue&type=style&index=0&id=adcd7650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcd7650",
  null
  
)

component.options.__file = "ProfilesBlock.vue"
export default component.exports